import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BFF_BASE_URL } from '../../../app.constants';
import { ExportUsersREQ } from '../../api';
import { EXPORT_USERS_API } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  #httpClient = inject(HttpClient);

  exportUsers(exportUsersReq: ExportUsersREQ) {
    const url = `${BFF_BASE_URL}${EXPORT_USERS_API}`;
    return this.#httpClient.post(url, exportUsersReq, {
      responseType: 'blob'
    });
  }
}
